import React from 'react';
import { Choose, ArrowItem, PopUp } from '@beisen/chaos-ui';
import * as uiUtil from '../../util/ui';
import { isEqualTo  } from '../../util/check';
import * as html from '../../util/html';
import transLoader from '@beisen/i18n-translation-loader';
import * as helper from '../../util/helper';
require('./ChooseComponent.scss');
const LIMIT_COUNT = 10;
const defaultTranslation = {
    selectHolder: '点击选择',
	required: '必填',
	clear: '清空',
    confirm: '确定',
	cancel: '取消',
	listEmpty: '暂时没有信息哦～',
	search: '搜索',
	emptyText: '这里什么都没有...'
};
class ChooseComponent extends React.Component {
	constructor(props) {
		super(props);
		this.changeHandler = this.changeHandler.bind(this);
		this.handlePanelClose = this.handlePanelClose.bind(this);
		this.handleTouchTap = this.handleTouchTap.bind(this);

		this.activeList = this.getActiveList();
		this.state = {
			isShowPanel: false
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            selectHolder: 'fieldPlaceHolder.selectHolder',
            required: 'common.required',
            clear: 'common.clear',
            confirm: 'common.confirm',
            cancel: 'common.cancel',
			listEmpty: 'common.listEmpty',
			emptyText: 'table.emptyText',
            search: 'common.search'
        }), props.translation);
	}

	getActiveList(nextProps) {
		const props = nextProps || this.props;
        let activeList = [];
        if(props.searchParams && props.searchParams.text) {
			let textArr = props.searchParams.text.split(',');
			let valueArr =  this.isString(props.searchParams.value) ? props.searchParams.value.split(',') : props.searchParams.value;

			textArr.forEach((item,index) => {
				activeList.push({ text: item, value: valueArr[index] });
			});
		}

		return activeList;
	}

	componentWillReceiveProps(nextProps) {
		this.activeList = this.getActiveList(nextProps);
	}

	changeHandler(objArr) {
		this.activeList = [];
		let obj = {};
		if(this.isMutiple) {
			let text = '';
			let value = '';
			objArr.forEach((item,index) => {
				text = text ?  text + ',' + item['text'] : item['text'];
				value = value ?  value + ',' + item['value'] : item['value'];
				this.activeList.push({ text: item['text'], value: item['value'] });
			});
			obj = { text, value };

		}else{
			obj = objArr[0];
			this.activeList.push({ text: objArr[0]['text'], value: objArr[0]['value'] });
		}
		if(this.props.pop_type == 'searchItem') {
			this.props.handleClosePopUp && this.props.handleClosePopUp();
			this.props.onChange && this.props.onChange(obj);
			this.props.synBizData && this.props.synBizData();
		}else {
			this.setState({ isShowPanel: false }, () => {
				this.props.onChange && this.props.onChange(obj);
			});
		}
	}

    handleTouchTap() {
		if(!document.getElementsByClassName('on-swipe')[0]) {
			this.setState({ isShowPanel: true });
		}
		if(this.props.onFocus) {
			this.props.onFocus();
		}
    }


    handlePanelClose() {
		this.props.pop_type !== 'searchItem' && this.setState({ isShowPanel: false });
		this.props.pop_type == 'searchItem' &&  this.props.handleCancel && this.props.handleCancel();
	}

    get isMutiple() {
         return this.props.cmp_type === 'BC_CheckBoxList' || (this.props.cmp_type === 'BC_DropDownList' && isEqualTo(this.props.cmp_data,['multiple'],true));
    }

    isString(val) {
        if(val) {
            return Object.prototype.toString.call(val) === '[object String]';
        }
        return false;
    }

    getFormContent() {
    	let chooseList;
    	if(this.props.cmp_data.cmp_state == 'create' || this.props.cmp_data.cmp_state == 'edit') {
    		chooseList = this.props.cmp_data.datasource || [];
    	}else {
    		chooseList = this.props.biz_data || [];
    	}

    	const activeList = this.activeList;
		if(this.isMutiple) {
			let formContent = [];
			chooseList.forEach((item,index) => {
				activeList.forEach(choose => {
					if(item['value'] === choose['value']) {
						formContent.push(item.text);
					}
				});
			});
			return formContent.join(',');
		}
		return activeList.length > 0 ? activeList[0]['text'] : '';
	}

	setBoxHeader(cnf) {
        helper.generateHeaderConfig(function(headerConfig, setButton) {
			let config = Object.assign({}, headerConfig);
			//设置左侧按钮
			config = setButton('left', cnf.left_item, config);
			//设置右侧按钮
            config = setButton('right', cnf.right_item, config);
			//设置中间数据
			config.titleItem = cnf.title_item;
			return config;
		});
    }

	renderPop(chooseList) {
		const visible = this.props.pop_type == 'searchItem' ? this.props.visible : this.state.isShowPanel;
		return (
			!visible ? null :
			<PopUp visible={true}
				onClose={this.handlePanelClose}
				cls={chooseList.length > LIMIT_COUNT ? 'search-chooose-popup' : 'choose_popup'}
				animation="bottom-slide-fade"
				maskAnimation="fade"
				wrapClassName={chooseList.length > LIMIT_COUNT ? 'search-chooose-wrap' : ''}
			>
				<Choose
					limitCount={LIMIT_COUNT}
					label={this.props.cmp_data.title}
					title={uiUtil.strEllipsis(this.props.cmp_data.title)}
					isMutiple={this.isMutiple}
					activeList={this.activeList}
					chooseList={chooseList}
					onChange={this.changeHandler}
					onFocus={this.props.onFocus}
					onCancel={this.handlePanelClose}
					style={{ maxHeight: '100%' }}
					ifHideNav={helper.ifHidePopupNav}
					setBoxHeader={this.setBoxHeader}
					decode={html.decode}
					clearHeaderConfig={helper.clearHeaderConfig}
					translation={this.translation}
				/>
			</PopUp>
		);
	}

    renderEditFormChoose() {
        const isDependenceField = !!this.props.cmp_data.depDataSource;
    	const chooseList = (isDependenceField ? this.props.cmp_data.depDataSource.dataSourceResults : this.props.cmp_data.datasource) || [];
    	const errMsg = this.props.errorMessage && this.props.errorMessage.message;
    	return 	(
		    <div>
				<ArrowItem label={this.props.cmp_data.title}
							desc={this.props.desc}
	                            type='text'
	                            required={this.props.required}
	                            errorMsg={errMsg}
	                            onClickForm={this.props.isReadOnly ? function() {
									return false;
								} : this.handleTouchTap}
	                            value={html.decode(this.getFormContent())}
								isReadOnly={this.props.isReadOnly}
								translation={this.translation}
                    styleTitle={this.props.styleTitle}
	            />
				{this.renderPop(chooseList)}
			</div>
		);
    }

    renderSearchItemChoose() {
    	const chooseList = this.props.biz_data || [];
    	return 	(
			chooseList.length > LIMIT_COUNT ?
			this.renderPop(chooseList) :
			<Choose
			   style={{ position: 'initial' }}
			   label={this.props.cmp_data.title}
			   title={uiUtil.strEllipsis(this.props.cmp_data.title)}
			   isMutiple={this.isMutiple}
			   activeList={this.activeList}
			   chooseList={chooseList}
			   onChange={this.changeHandler}
			   onFocus={this.props.onFocus}
			   handlePanelClose={this.props.synBizData}
			   pop_type={this.props.pop_type}
			   decode={html.decode}
			   translation={this.translation}
			/>
		);
    }

	render() {
		return this.props.pop_type == 'searchItem' ? this.renderSearchItemChoose() :
		       this.renderEditFormChoose();
	}
}
export default  ChooseComponent;



// WEBPACK FOOTER //
// ./src/components/Field_Components/ChooseComponent/ChooseComponent.js